import nl from './translation'

//Write here all the changes to translations that are not correct
nl.button.delete = "{target} verwijderen"
nl.label.multipleAmount = "hoeveelheid moet een veelvoud zijn van {target}"
nl.label.maxAmount = "Maximum aantal {target}"
nl.label.permission.promotion = "@:object.promotion"
nl.label.permission.message = "@:object.bericht"
nl.error.noMatch = "{target} komt niet overeen"
nl.error.notFound = "{target} werd niet gevonden. | {target} werd niet gevonden."
nl.error.invalid = "{target} is niet correct. | {target} is niet correct."
nl.error.empty = "{target} is leeg. | {target} is leeg."
nl.error.save = "{target} kon niet worden opgeslagen."
nl.error.delete = "{target} kon niet worden verwijderd."
nl.error.send = "{target} kon niet worden verzonden."
nl.error.load = "{target} kon niet worden geladen. | {target} kon niet worden geladen."
nl.messages.setting.welcome1 = "Hallo {name}"
nl.messages.home.welcome1 = "Hallo {name}"
nl.messages.location.welcome1 = "Hallo {name}"
nl.messages.order.sent = "Uw bestelling is succesvol verzonden naar {target}."
nl.messages.deliverer.allDeliverers = "Alle @:object.deliverer van {location}"
nl.messages.team.invite.joinTeam2 = "Je bent uitgenodigd voor de locatie {location} in de Octopus Bestel App!\n Gebruik de code {link} om lid te worden van uw nieuwe team.\n Voor Android: {appLinkAndroid}\n Voor IOS: {appLinkIOS}"
nl.messages.team.management.members = "Teamleden van {location}"
nl.messages.missingPermission = "Ontbrekende toestemming: {permission}"
nl.messages.cart.amount = "{amount} Geselecteerde artikelposities"
nl.messages.cart.selectionFrom = "Selectie bij {deliverer}"
nl.messages.register.thank = "Bedankt {name}"
nl.messages.didYouMean = "Bent u misschien op zoek naar {target}?"
nl.object.zipCity = "@object:postcode, @object:city"
nl.object.suggestion = "Product{hyphen}suggestie | Product{hyphen}suggestie"
nl.success.addCartNumber = "{target} @:success.addCart"
nl.success.save = "{target} is succesvol opgeslagen. | {target} is succesvol opgeslagen."
nl.success.delete = "{target} is verwijderd."
nl.success.deleteMulti = "{amount} {target} is verwijderd."
nl.success.send = "{target} is verzonden."
nl.success.create = "{target} is aangemaakt. | {target} werd aangemaakt."
nl.success.add = "{target} is toegevoegd. | {target} is toegevoegd."
nl.success.add = "{target} is toegevoegd. | {target} is toegevoegd."
nl.alert.delete.cartProduct = "Wilt u echt het product \"{target}\" uit de winkelwagen verwijderen?"
nl.alert.delete.supplier = "Wilt u {name} uit uw leveranciers verwijderen? Let op: Het verwijderen van een leverancier verwijdert ook alle lijsten voor deze leverancier."
nl.alert.delivererErrorMessage = "{target} kon niet worden toegevoegd aan uw locatie. Controleer de ingevoerde gegevens."
nl.label.day = 'Dag'
nl.messages.cart.amountItems = "{amount} enkel item"
export default nl
